import { DataGrid } from "@mui/x-data-grid";
import { Box, Card, IconButton, Skeleton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";
import moment from "moment";

const columns = [
  {
    flex: 1,
    field: "name",
    headerName: "Name",
    minWidth: 200,
    valueGetter: (params) => params.row.name,
  },
  {
    flex: 1,
    field: "slug",
    headerName: "Slug",
    maxWidth: 150,
    valueGetter: (params) => params.row.slug,
  },

  {
    flex: 1,
    field: "type",
    headerName: "Type",
    valueGetter: (params) => params.row.type,
  },
  {
    flex: 1,
    field: "createdAt",
    headerName: "Created On",
    maxWidth: 150,
    valueGetter: (params) =>
      moment(params.row.createdAt).format("MMMM Do YYYY"),
  },
  {
    flex: 1,
    field: "view",
    headerName: "Edit",
    sortable: false,
    maxWidth: 50,
    headerAlign: "center",
    align: "center",
    // flex: 1,
    disableClickEventBubbling: true,
    renderCell: (cell) => {
      return (
        <IconButton
          variant="outlined"
          component={Link}
          to={`/popular-search/edit/${cell.id}`}
        >
          <EditIcon />
        </IconButton>
      );
    },
  },

  {
    flex: 1,
    field: "delete",
    headerName: "Delete",
    sortable: false,
    maxWidth: 100,
    headerAlign: "center",
    align: "center",
    // flex: 1,
    disableClickEventBubbling: true,
    renderCell: (cell) => {
      return (
        <IconButton variant="contained">
          <DeleteIcon />
        </IconButton>
      );
    },
  },
];

const PopularSearchListing = ({
  isLoading,
  error,
  data,
  rowCountState,
  paginationModel,
  setPaginationModel,
  handleSelectPopularSearch,
}) => {
  function handleCellClick(params) {
    console.log(params);

    if (params.field === "delete") {
      handleSelectPopularSearch(params.row);
    }
  }

  if (isLoading) {
    return (
      <Skeleton
        sx={{
          transform: "scale(1, 1.0)",
          transformOrigin: "0% 0%",
        }}
        width="100%"
        height="600px"
      />
    );
  }

  if (error) {
    return <p>Something went wrong</p>;
  }

  return (
    <Card sx={{ p: 2 }}>
      <Box sx={{ height: 600, width: "100%" }}>
        <DataGrid
          // sx={{ width: "100%", overflowX: "scroll" }}
          rows={data?.popularSearchList}
          columns={columns}
          rowCount={rowCountState}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          loading={isLoading}
          paginationMode="server"
          onCellClick={handleCellClick}
        />
      </Box>
    </Card>
  );
};

export default PopularSearchListing;
